/**
 * After Recharge loads (DOM quiet), sync widget prices into
 * .block-price__regular .product-main-price and .product-compare-price (subscribe compare).
 */
;(function () {
  var QUIET_MS = 700
  var MAX_OBSERVE_MS = 60000
  var SERVING_DEBOUNCE_MS = 1200
  var LOG_DEDupe = true

  function rechargeWidgetRoot(section) {
    var el = section.querySelector('recharge-subscription-widget')
    if (el) return el
    var blocks = section.querySelectorAll('[id*="shopify-block"]')
    for (var i = 0; i < blocks.length; i++) {
      if (idLooksRecharge(blocks[i])) return blocks[i]
    }
    return section
  }

  function isNodeVisibleForPricing(node) {
    if (!node || !node.isConnected) return false
    var el = node.nodeType === 1 ? node : node.parentElement
    if (!el) return false
    var n = el
    while (n && n !== document.documentElement) {
      if (n.hidden) return false
      var st = window.getComputedStyle(n)
      if (st.display === 'none' || st.visibility === 'hidden') return false
      if (parseFloat(st.opacity || '1') === 0) return false
      n = n.parentElement
    }
    var rect = el.getBoundingClientRect()
    return rect.width >= 2 && rect.height >= 2
  }

  function selectedPlanBonus(node) {
    var r = node.closest && node.closest('[role="radio"]')
    if (r && r.getAttribute('aria-checked') === 'true') return 5000
    if (node.closest && node.closest('[aria-selected="true"]')) return 4000
    if (node.querySelector && node.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')) return 5000
    return 0
  }

  function moneyToNum(s) {
    var m = String(s || '').match(/[\d,]+(?:\.\d{2})?/)
    return m ? parseFloat(m[0].replace(/,/g, '')) : 0
  }

  function normalizeCompareAt(s) {
    if (!s) return ''
    var m = String(s).match(/\$\s*[\d,]+(?:\.\d{2})?/)
    return m ? m[0].replace(/\s+/g, '').trim() : String(s).trim()
  }

  function querySelectorAllDeep(root, selector, out) {
    if (!root || !root.querySelectorAll) return out
    if (root.nodeType === 1 && root.shadowRoot) {
      querySelectorAllDeep(root.shadowRoot, selector, out)
    }
    try {
      root.querySelectorAll(selector).forEach(function (el) {
        out.push(el)
      })
    } catch (_) {}
    var ch = root.children
    if (!ch) return out
    for (var i = 0; i < ch.length; i++) {
      var el = ch[i]
      querySelectorAllDeep(el, selector, out)
      if (el.shadowRoot) querySelectorAllDeep(el.shadowRoot, selector, out)
    }
    return out
  }

  function idLooksRecharge(el) {
    return String(el.id || '').toLowerCase().indexOf('recharge') !== -1
  }

  function rechargeLikelyPresent(section) {
    var blocks = section.querySelectorAll('[id*="shopify-block"]')
    for (var i = 0; i < blocks.length; i++) {
      if (idLooksRecharge(blocks[i])) return true
    }
    return !!(
      section.querySelector('recharge-subscription-widget') ||
      section.querySelector('[class*="recharge"], [class*="Recharge"]')
    )
  }

  function rowLooksSubscribe(t) {
    if (!t) return false
    if (!/subscribe|subscription/i.test(t)) return false
    if (!/\$/.test(t)) return false
    return true
  }

  function rowLooksOnetime(t) {
    if (!t) return false
    if (!/one[-\s]?time/i.test(t)) return false
    if (!/\$/.test(t)) return false
    return true
  }

  function parseSubscribeRow(node) {
    var t = node.textContent || ''
    if (!rowLooksSubscribe(t) || t.length > 900) return null
    var s = node.querySelector && node.querySelector('s')
    var strikeText = s ? String(s.textContent || '').trim() : ''
    var clone = node.cloneNode(true)
    var rm = clone.querySelectorAll('s')
    for (var j = 0; j < rm.length; j++) rm[j].remove()
    var after = clone.textContent || ''
    var money = after.match(/\$\s*[\d,]+(?:\.\d{2})?/g)
    if (!money || !money.length) return null
    var currentStr = money[money.length - 1].replace(/\s+/g, '').trim()
    if (!currentStr) return null
    var hasStrike = !!(s && /\$/.test(strikeText))
    if (!hasStrike && money.length >= 2) {
      strikeText = money[0].replace(/\s+/g, '').trim()
      hasStrike = /\$/.test(strikeText)
    }
    return {
      subscribePrice: currentStr,
      compareAtPrice: hasStrike ? strikeText : '',
      hasCompareAt: !!hasStrike,
    }
  }

  function parseOnetimeRow(node) {
    var t = node.textContent || ''
    if (!rowLooksOnetime(t) || t.length > 600) return null
    var clone = node.cloneNode(true)
    var rm = clone.querySelectorAll('s')
    for (var j = 0; j < rm.length; j++) rm[j].remove()
    var money = (clone.textContent || '').match(/\$\s*[\d,]+(?:\.\d{2})?/g)
    if (!money || !money.length) return null
    return { priceStr: money[money.length - 1].replace(/\s+/g, '').trim() }
  }

  function readRechargeWidgetPrices(section) {
    if (!rechargeLikelyPresent(section)) return null
    var root = rechargeWidgetRoot(section)
    var candidates = []
    querySelectorAllDeep(root, 'label', candidates)
    querySelectorAllDeep(root, 'div[role="radio"]', candidates)
    querySelectorAllDeep(root, 'div[role="button"]', candidates)
    var best = null
    var bestScore = -1
    var oneTimeBest = ''
    var oneTimeBestNum = -1
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i]
      if (!isNodeVisibleForPricing(el)) continue
      var ot = parseOnetimeRow(el)
      if (ot && ot.priceStr) {
        var on = moneyToNum(ot.priceStr)
        if (on > oneTimeBestNum) {
          oneTimeBestNum = on
          oneTimeBest = ot.priceStr
        }
      }
      var parsed = parseSubscribeRow(el)
      if (!parsed) continue
      var sc = selectedPlanBonus(el) + (parsed.hasCompareAt ? 1000 : 0)
      if (sc > bestScore) {
        bestScore = sc
        best = parsed
      } else if (sc === bestScore && best && moneyToNum(parsed.subscribePrice) > moneyToNum(best.subscribePrice)) {
        best = parsed
      }
    }
    if (!best || !best.subscribePrice) return null
    return {
      subscribePrice: best.subscribePrice,
      compareAtPrice: normalizeCompareAt(best.compareAtPrice || ''),
      oneTimePrice: oneTimeBest || '',
    }
  }

  function readIsOnetime(section) {
    var form = document.getElementById('product-form-' + section.dataset.sectionId)
    var sel =
      'input[name="selling_plan"],select[name="selling_plan"],input.selling_plan-id,input[name^="selling_plan"]'
    var fields = []
    var seen = new Set()
    function add(el) {
      if (el && !seen.has(el)) {
        seen.add(el)
        fields.push(el)
      }
    }
    if (form) {
      try {
        if (form.elements && form.elements.namedItem) {
          var n = form.elements.namedItem('selling_plan')
          if (n) {
            if (typeof n.length === 'number' && n[0]) {
              for (var i = 0; i < n.length; i++) add(n[i])
            } else add(n)
          }
        }
        form.querySelectorAll(sel).forEach(add)
      } catch (_) {}
    }
    try {
      section.querySelectorAll(sel).forEach(add)
    } catch (_) {}
    if (!fields.length) return null
    var value = ''
    for (var j = 0; j < fields.length; j++) {
      var v = String(fields[j].value || '').trim()
      if (v !== '') {
        value = v
        break
      }
    }
    return value === ''
  }

  /**
   * Subscribe → main = w.subscribePrice, compare = w.compareAtPrice when present.
   * One-time → main = one-time/origin; compare cleared.
   * Nodes: .block-price__regular .product-main-price | .product-compare-price
   */
  function applyMainPriceFromWidget(section, w) {
    if (!section) return
    var isOt = readIsOnetime(section)
    if (isOt === null) return
    var el = document.querySelector('.block-price__regular .product-main-price')
    if (!el) return
    var compareEl = document.querySelector('.block-price__regular .product-compare-price')
    var next = ''
    var compareNext = ''
    if (isOt === false) {
      if (!w || !w.subscribePrice) return
      next = w.subscribePrice
      if (w.compareAtPrice) compareNext = String(w.compareAtPrice).trim()
    } else {
      if (!w) return
      next = (w.oneTimePrice || w.compareAtPrice || '').trim()
      if (!next) return
    }
    var mainSame = String(el.textContent || '').replace(/\s+/g, '') === String(next).replace(/\s+/g, '')
    var compareSame =
      !compareEl ||
      String(compareEl.textContent || '').replace(/\s+/g, '') === String(compareNext).replace(/\s+/g, '')
    if (mainSame && compareSame) return
    section.__brsApplyingPrice = true
    try {
      el.textContent = next
      if (compareEl) compareEl.textContent = compareNext
    } catch (_) {}
    requestAnimationFrame(function () {
      section.__brsApplyingPrice = false
    })
  }

  function attach(section) {
    if (!section || !section.dataset || !section.dataset.sectionId) return

    if (section.__brsRechargeSubscribeMo) {
      try {
        section.__brsRechargeSubscribeMo.disconnect()
      } catch (_) {}
      section.__brsRechargeSubscribeMo = null
    }
    if (section.__brsRechargeSubscribeQuietTimer) {
      clearTimeout(section.__brsRechargeSubscribeQuietTimer)
      section.__brsRechargeSubscribeQuietTimer = null
    }
    if (section.__brsServingLogTimer) {
      clearTimeout(section.__brsServingLogTimer)
      section.__brsServingLogTimer = null
    }
    if (section.__brsServingPickerHandler) {
      section.removeEventListener('click', section.__brsServingPickerHandler, true)
      section.__brsServingPickerHandler = null
    }

    if (section.__brsBrocshotPriceHandler) {
      window.removeEventListener('brocshot:purchase-type', section.__brsBrocshotPriceHandler)
      section.__brsBrocshotPriceHandler = null
    }

    var sectionId = section.dataset.sectionId || ''
    var t0 = Date.now()
    var lastLogKey = ''

    function tryLog() {
      try {
        if (!section.isConnected) return
        var w = readRechargeWidgetPrices(section)
        if (!w) return
        var key = sectionId + '|' + w.subscribePrice + '|' + (w.compareAtPrice || '')
        if (!LOG_DEDupe || key !== lastLogKey) {
          lastLogKey = key
        }
        applyMainPriceFromWidget(section, w)
      } catch (_) {}
    }

    function schedule() {
      if (Date.now() - t0 > MAX_OBSERVE_MS) return
      if (section.__brsRechargeSubscribeQuietTimer) clearTimeout(section.__brsRechargeSubscribeQuietTimer)
      section.__brsRechargeSubscribeQuietTimer = setTimeout(function () {
        section.__brsRechargeSubscribeQuietTimer = null
        tryLog()
      }, QUIET_MS)
    }

    function logServingWidgetPrices(servingChoice) {
      try {
        if (!section.isConnected) return
        var w = readRechargeWidgetPrices(section)
        if (w) applyMainPriceFromWidget(section, w)
      } catch (_) {}
    }

    section.__brsBrocshotPriceHandler = function (ev) {
      var d = ev.detail
      if (!d || String(d.sectionId) !== String(sectionId)) return
      if (d.is_Onetime === null) return
      requestAnimationFrame(function () {
        var wp = readRechargeWidgetPrices(section)
        applyMainPriceFromWidget(section, wp)
      })
    }
    window.addEventListener('brocshot:purchase-type', section.__brsBrocshotPriceHandler)

    section.__brsServingPickerHandler = function (e) {
      var item = e.target.closest && e.target.closest('.brs-format-serving__item[data-serving-choice]')
      if (!item || !section.contains(item)) return
      var choice = item.getAttribute('data-serving-choice') || ''
      if (choice !== 'single' && choice !== 'double') return
      if (section.__brsServingLogTimer) clearTimeout(section.__brsServingLogTimer)
      section.__brsServingLogTimer = setTimeout(function () {
        section.__brsServingLogTimer = null
        logServingWidgetPrices(choice)
      }, SERVING_DEBOUNCE_MS)
    }
    section.addEventListener('click', section.__brsServingPickerHandler, true)

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        if (section.__brsApplyingPrice) return
        schedule()
      })
      mo.observe(section, { subtree: true, childList: true, attributes: true })
      section.__brsRechargeSubscribeMo = mo
    }

    schedule()
    setTimeout(tryLog, QUIET_MS + 150)
  }

  function boot() {
    document.querySelectorAll('section.page-content--product[data-section-id]').forEach(attach)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(boot)
  })
})()
